'use client'

import { LineArrowLeft } from '@qr-front/icons/line-arrow-left'
import { buttonCls } from '@qr-front/ui/components/Button'
import { cn } from '@qr-front/ui/utils'
import { getVersionForClone } from '@qr-front/ui/utils'
import { useTranslations } from 'next-intl'

import { Link } from '@/i18n-routing'

import { captureBuilderEvent, STEP_TO_INDEX } from '../../builderAnalytics'
import { useCurrGeneratorStep } from '../../hooks'

export const ButtonBackDesktop = ({ url }: { url: string }) => {
	const t = useTranslations()

	const currStep = useCurrGeneratorStep()

	if (currStep === 'type') {
		return null
	}

	const handleClick = () => {
		captureBuilderEvent('builder_step_back', {
			step_index: STEP_TO_INDEX[currStep],
			section: 'wizard_stepper',
		})
	}

	return (
		<Link
			href={url}
			onClick={handleClick}
			className={cn(
				buttonCls({ visual: 'text' }),
				'type-body-medium gap-2 has-[>svg]:px-0',
				getVersionForClone({
					base: '',
					clone1: 'has-[>svg]:type-body-medium',
				}),
			)}
		>
			<LineArrowLeft className="size-4" />
			{t('generator__footer__back_button')}
		</Link>
	)
}
